import { combineReducers } from "redux"

import endCustomerPrices from "./end-customer-prices"

export default combineReducers({
  endCustomerPrices
})
